import type { TimeOfDay } from "cmw-client";

export const TIME_STEP_MINUTES = 30;

const MINUTES_PER_DAY = 24 * 60;

export const toMinutes = (time: TimeOfDay): number => {
  const [hours, minutes] = time.split(":").map(Number);
  return (hours ?? 0) * 60 + (minutes ?? 0);
};

export const fromMinutes = (minutes: number): TimeOfDay => {
  const hours = Math.floor(minutes / 60);
  const remainder = minutes % 60;
  return `${String(hours).padStart(2, "0")}:${String(remainder).padStart(2, "0")}`;
};

export const formatTimeOfDay = (time: TimeOfDay): string => {
  const minutes = toMinutes(time);
  const hours24 = Math.floor(minutes / 60);
  const mins = minutes % 60;
  const period = hours24 < 12 ? "AM" : "PM";
  const hours12 = hours24 % 12 === 0 ? 12 : hours24 % 12;
  return `${hours12}:${String(mins).padStart(2, "0")} ${period}`;
};

export const timeOptions = (): { value: TimeOfDay; label: string }[] => {
  const options: { value: TimeOfDay; label: string }[] = [];
  for (let minutes = 0; minutes < MINUTES_PER_DAY; minutes += TIME_STEP_MINUTES) {
    const value = fromMinutes(minutes);
    options.push({ value, label: formatTimeOfDay(value) });
  }
  return options;
};

export const formatDuration = (start: TimeOfDay, end: TimeOfDay): string => {
  const totalMinutes = toMinutes(end) - toMinutes(start);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (hours <= 0) return `${minutes}m`;
  if (minutes === 0) return `${hours}h`;
  return `${hours}h ${minutes}m`;
};

export const normalizeTimeQuery = (input: string): string => input.toLowerCase().replace(/[\s:.]/g, "");
